@if (loading()) {
  <div class="flex justify-center py-6">
    <nz-spin nzSimple></nz-spin>
  </div>
} @else if (document()) {
  <app-consent-view/>
}
